import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { GoogleButton } from "../components/GoogleButton";
import { startGoogleSignIn } from "../lib/googleAuth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const input = "mt-2 h-12 w-full border border-white/15 bg-black/40 px-4 text-sm text-white focus:border-[#a259ff] focus:outline-none";

  return (
    <div className="grain grid-lines grid min-h-screen place-items-center bg-[#07070b] px-5">
      <form onSubmit={submit} className="w-full max-w-md border border-white/10 bg-[#0b0b11] p-8" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-8 font-display text-5xl uppercase text-white">Owner access</h1>
        <p className="mt-3 text-sm text-slate-300" data-testid="admin-login-customer-hint">Customer? <Link to="/account" className="text-[#e9d5ff] underline" data-testid="admin-login-customer-link">Sign in to My orders here</Link>. This page is only for the store owner.</p>
        <div className="mt-6">
          <GoogleButton onClick={() => startGoogleSignIn("/admin")} label="Sign in with Google" testId="admin-google-signin" />
        </div>
        <p className="mt-6 flex items-center gap-3 font-mono text-[11px] uppercase tracking-widest text-slate-400"><span className="h-px flex-1 bg-white/10" />or use password<span className="h-px flex-1 bg-white/10" /></p>
        <label className="mt-6 block font-mono text-[11px] uppercase tracking-widest text-slate-400">
          Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="admin-login-email-input" />
        </label>
        <label className="mt-4 block font-mono text-[11px] uppercase tracking-widest text-slate-400">
          Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="admin-login-password-input" />
        </label>
        {error && <p className="mt-4 text-sm text-[#ff7ad9]" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="mt-6 flex h-12 w-full items-center justify-center gap-2 bg-[#a259ff] font-mono text-xs font-bold uppercase tracking-widest text-black disabled:opacity-60" data-testid="admin-login-submit-button">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
        <Link to="/admin/forgot" className="mt-4 block text-center font-mono text-xs uppercase tracking-widest text-slate-400 hover:text-white" data-testid="admin-forgot-link">Forgot password?</Link>
      </form>
    </div>
  );
}
